import React from 'react'
import Layout from '../components/layout'
import SEO from '../components/seo'

const NotFoundPage = () => (
  <Layout>
    <SEO 
      title="Page Not Found"
      description="The page you're looking for doesn't exist."
      noindex={true}
    />
    <div style={{ textAlign: 'center', padding: '4rem 0' }}>
      <h1>404: Page Not Found</h1>
      <p>Sorry, the page you're looking for doesn't exist.</p>
      <a href="/">← Go back home</a>
    </div>
  </Layout>
)

export default NotFoundPage
